import { i18n } from '../services/i18n.js';
import { dbSim } from '../services/dbSim.js';
import { escapeHTML } from '../services/sanitize.js';
import { icon } from '../services/icons.js';

export const ReportView = async (container, params) => {
  // Auth Guard
  if (!localStorage.getItem("h150_auth_user")) {
    window.location.hash = '#/login';
    return;
  }

  container.innerHTML = `<div class="container" style="padding:40px; text-align:center; color:var(--color-text-secondary);">${i18n.t('loading_report')}</div>`;

  const report = await dbSim.getSessionReport(params.id);
  if (!report) {
    window.showToast("Báo cáo không tồn tại!");
    window.location.hash = '#/dashboard';
    return;
  }

  container.innerHTML = `
    <div class="container report-page">
      <header class="report-header">
        <a href="#/dashboard" class="icon-link" aria-label="${i18n.t('back_to_dashboard')}">${icon('arrowLeft')}</a>
        <div>
          <h1>${i18n.t('report_title')}</h1>
          <p>${escapeHTML(report.gameTitle)}</p>
        </div>
      </header>

      <section class="report-summary" aria-label="${i18n.t('report_summary')}">
        <div><strong>${report.participantsCount}</strong><span>${i18n.t('players')}</span></div>
        <div><strong>${report.completionRate}%</strong><span>${i18n.t('completed')}</span></div>
        <div><strong>${report.averageScore}</strong><span>${i18n.t('report_avg_score')}</span></div>
      </section>

      <div class="report-disclosures">
        <details>
          <summary><span>${icon('trophy')} ${i18n.t('leaderboard_title')}</span><span>${report.topPlayers.length} ${i18n.t('leaderboard_people')}</span></summary>
          <div class="disclosure-content">
            ${report.topPlayers.map((player, idx) => `
              <div class="report-row">
                <span>${idx + 1}. ${escapeHTML(player.nickname)}</span>
                <strong>${player.score} ${i18n.t('play_points')}</strong>
              </div>
            `).join('') || `<p>${i18n.t('no_data')}</p>`}
          </div>
        </details>

        <details>
          <summary><span>${icon('lightBulb')} ${i18n.t('review_question')}</span><span>${i18n.t('view_details')}</span></summary>
          <div class="disclosure-content">
            <strong>${escapeHTML(report.toughestQuestion)}</strong>
            <p>${i18n.t('toughest_help')}</p>
          </div>
        </details>
      </div>
    </div>
  `;
};
